import logomain from "../../images/logo.png";
import profileimg from "../../images/profile-img.png";
import collapse from "../../images/collapse.svg";
import "../../css/pages/dashboard.css";
import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { DashboardFunction } from "./DashboardFunction";
import { LoadPanel, Popup, Toast } from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../../Components/Logout";

const LogoutPopup = ({ setLogoutPopupShow, LogoutPopupShow }) => {
  return (
    <>
      <Popup
        visible={LogoutPopupShow}
        onHiding={() => {
          setLogoutPopupShow(false);
        }}
        showTitle={false}
        width={455}
        height={280}
        showCloseButton={true}
        hideOnOutsideClick={true}
      >
        <Logout
          setLogoutPopupShow={setLogoutPopupShow}
          LogoutPopupShow={LogoutPopupShow}
        />
      </Popup>
    </>
  );
};

export const Dashboard = () => {
  const navigation = useNavigate();
  const clas = new DashboardFunction();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, viewData } = useSelector((store) => store.dashboard);
  const [sideBarToggel, setsideBarToggel] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (!localStorage.getItem("Token")) {
      navigation("/login");
    }
  }, [navigation]);

  useEffect(() => {
    clas.getUserDetail(setLoading, dispatch, setToastConfig, toastConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const [logouthover, setlogouthover] = useState(false);
  const [LogoutPopupShow, setLogoutPopupShow] = useState(false);

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <LogoutPopup
        LogoutPopupShow={LogoutPopupShow}
        setLogoutPopupShow={setLogoutPopupShow}
      />

      <main className="main">
        <div>
          <aside
            className={!sideBarToggel ? `sidebar` : "sidebar activesidebar"}
          >
            <ul className="nav nav--column">
              <li className="nav__item">
                <div className="sidebar__branding">
                  <Link>
                    <img
                      className="sidebar__logo"
                      src={logomain}
                      alt="Logo | Welcome To UPA"
                    />
                  </Link>
                </div>
              </li>
              <li
                onClick={() => {
                  navigation("/dashboard/app-list");
                }}
                className="nav__item"
                style={{
                  cursor: "pointer",
                  marginTop: "6px",
                }}
              >
                <div style={{ alignItems: "center", display: "flex" }}>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width={25}
                    height={24}
                    viewBox="0,0,256,245.75"
                  >
                    <g
                      fill="rgb(4, 117, 215)"
                      fillRule="nonzero"
                      stroke="none"
                      strokeWidth={1}
                      strokeLinecap="butt"
                      strokeLinejoin="miter"
                      strokeMiterlimit={10}
                      strokeDasharray=""
                      strokeDashoffset={0}
                      fontFamily="none"
                      fontWeight="none"
                      fontSize="none"
                      textAnchor="none"
                      style={{ mixBlendMode: "normal" }}
                    >
                      <g transform="translate(-3.13979,-0.005) scale(10.24,10.24)">
                        <path d="M22.3066,10.9v-6.8c0,-1.5 -0.64,-2.1 -2.23,-2.1h-4.04c-1.59,0 -2.23,0.6 -2.23,2.1v6.8c0,1.5 0.64,2.1 2.23,2.1h4.04c1.59,0 2.23,-0.6 2.23,-2.1z" />
                        <path d="M11.8066,13.1v6.8c0,1.5 -0.64,2.1 -2.22996,2.1h-4.04c-1.59,0 -2.23,-0.6 -2.23,-2.1v-6.8c0,-1.5 0.64,-2.1 2.23,-2.1h4.04c1.58996,0 2.22996,0.6 2.22996,2.1z" />
                        <path d="M22.3066,19.9v-2.8c0,-1.5 -0.64,-2.1 -2.23,-2.1h-4.04c-1.59,0 -2.23,0.6 -2.23,2.1v2.8c0,1.5 0.64,2.1 2.23,2.1h4.04c1.59,0 2.23,-0.6 2.23,-2.1z" />
                        <path d="M11.8066,6.9v-2.8c0,-1.5 -0.64,-2.1 -2.22996,-2.1h-4.04c-1.59,0 -2.23,0.6 -2.23,2.1v2.8c0,1.5 0.64,2.1 2.23,2.1h4.04c1.58996,0 2.22996,-0.6 2.22996,-2.1z" />
                      </g>
                    </g>
                  </svg>

                  <p
                    style={{
                      marginLeft: "4%",
                      color: "#0475d7",
                      fontWeight: "bold",
                    }}
                  >
                    Home
                  </p>
                </div>
              </li>
              <li
                onClick={() => {
                  setLogoutPopupShow(true);
                }}
                onMouseEnter={() => {
                  setlogouthover(true);
                }}
                onMouseLeave={() => {
                  setlogouthover(false);
                }}
                className="nav__item"
                style={{ cursor: "pointer", marginTop: "25px" }}
              >
                <div style={{ alignItems: "center", display: "flex" }}>
                  <svg
                    width={27}
                    height={26}
                    viewBox="0 0 27 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_2_2193)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.20046 0.682495C2.16605 0.682495 0.516846 2.3317 0.516846 4.3661V22.7842C0.516846 24.8186 2.16605 26.4678 4.20046 26.4678H22.6185C24.6529 26.4678 26.3021 24.8186 26.3021 22.7842V4.3661C26.3021 2.3317 24.6529 0.682495 22.6185 0.682495H4.20046ZM9.72472 4.3661C8.70752 4.3661 7.88291 5.19071 7.88291 6.20791V20.9424C7.88291 21.9596 8.70752 22.7842 9.72472 22.7842C10.7419 22.7842 11.5665 21.9595 11.5665 20.9423V6.20791C11.5665 5.1907 10.7419 4.3661 9.72472 4.3661Z"
                        fill={logouthover ? "rgb(4, 117, 215)" : "#A1A1AA"}
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2_2193">
                        <rect
                          width="25.7853"
                          height="25.7853"
                          fill="white"
                          transform="translate(0.515625 0.119141)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <p
                    style={{
                      marginLeft: "4%",
                      fontWeight: "bold",
                      color: logouthover && "rgb(4, 117, 215)",
                    }}
                  >
                    Logout
                  </p>
                </div>
              </li>
            </ul>
          </aside>
        </div>
        <div className="content">
          <div>
            <nav style={{ height: "57px" }} className="navbar">
              <div className="navbar__menu">
                <ul className="navbar__nav nav">
                  <li>
                    <p
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigation("/dashboard/app-list");
                      }}
                      className="nav__link"
                    >
                      Dashboard
                    </p>
                  </li>
                  {viewData?.app_name && (
                    <>
                      <p
                        style={{
                          marginTop: "7px",
                          fontSize: "20px",
                          color: "#9a9da1",
                        }}
                      >
                        {">"}
                      </p>
                      <li>
                        <p style={{ color: "#0475d7" }} className="nav__link">
                          All Apps
                        </p>
                      </li>
                    </>
                  )}
                  {viewData?.app_name && (
                    <>
                      <p
                        style={{
                          marginTop: "7px",
                          fontSize: "20px",
                          color: "#9a9da1",
                        }}
                      >
                        {">"}
                      </p>
                      <li>
                        <p style={{ color: "#0475d7" }} className="nav__link">
                          {viewData?.app_name}
                        </p>
                      </li>
                    </>
                  )}
                </ul>
                <ul className="navbar__nav nav">
                  <li className="nav__item">
                    <Link className="nav__link nav__link--profile">
                      <img
                        className="profileimg"
                        src={profileimg}
                        alt="Alex Gold"
                      />
                      <span className="profileInfo">
                        {userInfo?.fullName}
                        <span className="profileInfo__position">
                          {userInfo?.email}
                        </span>
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="pagetitle">
            <button
              onClick={() => {
                setsideBarToggel(!sideBarToggel);
              }}
              id="sidebarCollapse"
            >
              <img src={collapse} alt="Collapse Icon" />
            </button>
          </div>
          <div className="dashboard">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};
